import '../App.css';
import '../css/Nav design.css';
import '../css/Viewpage.css';
import { useState, useEffect } from 'react';
import { Oval } from "react-loader-spinner";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import ApiConfig from '../utils/ApiConfig';
import ApiResponse from '../model/response/ApiResponse';
import { toast, ToastContainer } from 'react-toastify';
import Popup from './Popup';
import BlockedUserResponse from '../model/response/BlockedUserResponse';
import logo from '../images/logo.jpeg';
import ProfileImageResponse from '../model/response/ProfileImageResponse';

function Settingspage() {
    const navigation = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [showBlockList, setShowBlockList] = useState(false);
    const [deleteReason, setDeleteReason] = useState('');
    const [blockedUsers, setBlockedUsers] = useState([]);
    const [showProfileControl, setShowProfileControl] = useState(false);
    const [controlList, setControlList] = useState([]);
    const [isSavingImageControl, setIsSavingImageControl] = useState(false);

    const [selectedControls, setSelectedControls] = useState([]);

    const rawVal = localStorage.getItem('loginVal');
    let loginVal = rawVal ? JSON.parse(rawVal) : null;
    let token = localStorage.getItem('token');

    const showToast = (message) => toast.success(message, { position: "top-right", autoClose: 2000 });
    const showToastFailed = (message) => toast.error(message, { position: "top-right", autoClose: 2000 });

    const imageProfile = () => {

        setIsLoading(true);

        axios.get(
            ApiConfig.getUrl("User/getImageLookUp"),
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
            .then(controlResponse => {

                const controlApi = ApiResponse.fromJson(controlResponse.data);

                if (controlApi.statusCode === 200) {
                    setControlList(controlApi.response || []);
                }

                getProfileImageAPIcall();

                setShowProfileControl(true);
                setIsLoading(false);
            })
            .catch(error => {
                setIsLoading(false);
                console.error(error);
            });
    };

    const saveImageControl = () => {

        if (selectedControls.length === 0) {
            showToastFailed("Select at least one option");
            return;
        }

        setIsSavingImageControl(true);

        axios.post(
            ApiConfig.getUrl("User/imagePrivacySetting"),
            {
                user_Id: loginVal.user_Id,
                visibility: selectedControls.join(","),
                loggedInUser_Id: loginVal.user_Id
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
            .then(response => {

                const api = ApiResponse.fromJson(response.data);

                if (api.statusCode === 200) {
                    showToast("Saved Successfully");

                    // Popup close panna வேண்டாம்
                    // setShowProfileControl(false);
                } else {
                    showToastFailed(api.errorMessage);
                }
            })
            .catch(error => {
                console.error(error);
                showToastFailed("Save Failed");
            })
            .finally(() => {
                setIsSavingImageControl(false);
            });
    };



    function getProfileImageAPIcall() {
        setIsLoading(true);

        axios.get(
            ApiConfig.getUrl("User/GetImageSettings"),
            {
                params: {
                    user_Id: loginVal.user_Id
                },
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                }
            }
        )
            .then(response => {

                console.log("API Response:", response.data);

                const visibility = response.data?.response?.visibility;

                const values = visibility
                    ? visibility.split(",").map(Number)
                    : [];

                console.log("Selected Values:", values);

                setSelectedControls(values);

                setIsLoading(false);
            })
            .catch(error => {
                setIsLoading(false);
                console.error(error);
            });
    }

    //    function getProfileImageAPIcall() {

    //     axios.get(
    //         ApiConfig.getUrl("User/GetImageSettings"),
    //         {
    //             params: {
    //                 userId: loginVal.user_Id
    //             },
    //             headers: {
    //                 "Content-Type": "application/json",
    //                 Authorization: `Bearer ${token}`
    //             }
    //         }
    //     )


    //     .then(response => {
    //                 const api = ApiResponse.fromJson(response.data);
    //                 console.log("Response:", api.statusCode);

    //                  if (api.statusCode === 200) {

    //         const values = api.response?.visibility
    //             ? api.response.visibility.split(",").map(Number)
    //             : [];

    //         console.log("Values:", values);

    //         setSelectedControls(values);
    //           setIsLoading(false);

    //     }




    // Implementation for fetching blocked users
    const fetchBlockedUsers = () => {
        setIsLoading(true);
        axios.get(ApiConfig.getUrl("User/blockList"), {
            params: { userId: loginVal.user_Id },
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            }
        })
            .then(response => {
                const api = ApiResponse.fromJson(response.data);
                if (api.statusCode === 200) {
                    const list = api.response?.map(item => BlockedUserResponse.fromJson(item)) || [];
                    setBlockedUsers(list);
                    setShowBlockList(true);
                } else {
                    showToastFailed(api.errorMessage || "Failed to fetch blocked users");
                }
                setIsLoading(false);
            })
            .catch(error => {
                setIsLoading(false);
                console.error(error);
                showToastFailed("Error fetching blocked users");
            });
    };

    // Implementation for unblocking a user
    const handleUnblock = (blockId) => {
        setIsLoading(true);
        const blockRequest = {
            user_Id: loginVal.user_Id,
            block_Id: blockId
        };
        axios.post(ApiConfig.getUrl("User/user_block"), JSON.stringify(blockRequest), {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            }
        })
            .then(response => {
                const api = ApiResponse.fromJson(response.data);
                if (api.statusCode === 200) {
                    showToast("Block status updated");
                    setBlockedUsers(prev => prev.filter(u => u.userId !== blockId));
                } else {
                    showToastFailed(api.errorMessage);
                }
                setIsLoading(false);
            })
            .catch(error => {
                setIsLoading(false);
                showToastFailed("Failed to update block status");
            });
    };

    // Implementation for account deletion
    const handleDeleteAccount = () => {
        if (!deleteReason) {
            showToastFailed("Please select a reason for deletion.");
            return;
        }
        setIsLoading(true);
        const deleteRequest = {
            userId: loginVal.user_Id,
            modifiedBy: loginVal.user_Id,
            reason: deleteReason
        };
        axios.delete(ApiConfig.getUrl("User/soft-delete"), {
            data: deleteRequest, // Send data in the request body for DELETE
            headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` }
        })
            .then(response => {
                const api = ApiResponse.fromJson(response.data);
                if (api.statusCode === 200) {
                    showToast("Account deleted successfully");
                    localStorage.clear();
                    navigation('/login');
                } else {
                    showToastFailed(api.errorMessage || "Failed to delete account");
                }
                setIsLoading(false);
            })
            .catch(error => {
                setIsLoading(false);
                console.error(error);
                showToastFailed("Error deleting account");
            });
    };

    const handleControlChange = (code) => {
        setSelectedControls((prev) =>
            prev.includes(code)
                ? prev.filter((x) => x !== code)
                : [...prev, code]
        );
    };



    const disableRightClick = (e) => {
        e.preventDefault();
    };


    return (
        <>
            <div className='fullview' onContextMenu={disableRightClick}>
                <ToastContainer />
                {isLoading && (
                    <div className="loader-overlay">
                        <Oval height={60} width={60} color="orange" secondaryColor="#cccccc" strokeWidth={4} visible={true} />
                    </div>
                )}

                <div className="top-bar shadow-sm">
                    <div className='container'>
                        <ul className="d-flex align-items-center mb-0">
                            <img src={logo} alt='logo' style={{ width: '70px', cursor: 'pointer' }} onClick={() => navigation('/Viewpage')} />
                            <li className='ms-auto' style={{ listStyle: 'none', cursor: 'pointer' }} onClick={() => navigation('/Viewpage')}>
                                <i className="bi bi-house me-1"></i>Home
                            </li>
                        </ul>
                    </div>
                </div>

                <div className='container my-5 center'>
                    <h2 className='mb-4'>Account Settings</h2>

                    <div className="card shadow-sm border-0 rounded-3">
                        <div className="list-group list-group-flush">
                            <button className="list-group-item list-group-item-action d-flex justify-content-between align-items-center py-3" onClick={fetchBlockedUsers}>
                                <span><i className="bi bi-slash-circle me-3 text-primary"></i>Blocked Users</span>
                                <i className="bi bi-chevron-right text-muted"></i>
                            </button>

                            <button
                                className="list-group-item list-group-item-action d-flex justify-content-between align-items-center py-3"
                                onClick={imageProfile}
                            >
                                <span>
                                    <i className="bi bi-person me-3 text-primary"></i>
                                    Profile Control
                                </span>

                                <i className="bi bi-chevron-right text-muted"></i>
                            </button>

                            <button className="list-group-item list-group-item-action d-flex justify-content-between align-items-center py-3" onClick={() => navigation('/Changepassword', { state: { userId: loginVal.user_Id } })}>
                                <span><i className="bi bi-key me-3 text-primary"></i>Update Password</span>
                                <i className="bi bi-chevron-right text-muted"></i>
                            </button>

                            <button className="list-group-item list-group-item-action d-flex justify-content-between align-items-center py-3" onClick={() => navigation('/PrivacyPolicy')}>
                                <span><i className="bi bi-shield-lock me-3 text-primary"></i>Privacy Policy</span>
                                <i className="bi bi-box-arrow-up-right text-muted"></i>
                            </button>

                            <button className="list-group-item list-group-item-action d-flex justify-content-between align-items-center py-3" onClick={() => navigation('/TermsAndConditions')}>
                                <span><i className="bi bi-file-text me-3 text-primary"></i>Terms and Conditions</span>
                                <i className="bi bi-box-arrow-up-right text-muted"></i>
                            </button>

                            <button className="list-group-item list-group-item-action d-flex justify-content-between align-items-center py-3 text-danger" onClick={() => setShowDeletePopup(true)}>
                                <span><i className="bi bi-trash me-3"></i>Delete Account</span>
                                <i className="bi bi-chevron-right"></i>
                            </button>
                        </div>
                    </div>
                </div>

                {/* Block List Popup */}
                <Popup show={showBlockList} title="Blocked Users" onClose={() => setShowBlockList(false)}>
                    {/* Content for Block List Popup */}

                    <div className="modal-body p-3" style={{ minWidth: '300px' }}>
                        <div style={{ maxHeight: '300px', overflowY: 'auto', border: '1px solid #eee', borderRadius: '5px' }}>
                            {blockedUsers.length > 0 ? ( // Added border-bottom to list items
                                <ul className="list-group list-group-flush">
                                    {blockedUsers.map(user => (
                                        <li key={user.userId} className="list-group-item d-flex justify-content-between align-items-center px-0">
                                            <div>
                                                <div className="fw-bold">{user.name}</div>
                                                <small className="text-muted">IMIT{user.userId}</small>
                                            </div>
                                            <button className="btn btn-sm btn-outline-danger" onClick={() => handleUnblock(user.userId)}>Unblock</button>
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <div className="text-center py-4">
                                    <i className="bi bi-people text-muted display-6"></i>
                                    <p className="mt-2 mb-0">No blocked users.</p>
                                </div>
                            )}
                        </div>
                    </div>
                </Popup>

                {/* Delete Confirmation Popup */}
                <Popup show={showDeletePopup}
                    title="Delete Account?"
                    onClose={() => setShowDeletePopup(false)}>

                    {/* Content for Delete Confirmation Popup */}
                    {/* <div className="modal-header">
                   
                    <button type="button" className="btn-close" aria-label="Close" onClick={() => setShowDeletePopup(false)}></button>
                </div> */}
                    <div className="modal-body p-4 text-center">
                        <i className="bi bi-exclamation-triangle text-danger display-5 mb-3"></i>
                        <h4 className="fw-bold">Are you sure?</h4>
                        <p className="text-muted mb-3">This action is permanent and cannot be undone. You will lose access to your profile and matches.</p>
                        <div className="mb-4">
                            <label htmlFor="deleteReason" className="form-label visually-hidden">Reason for deletion</label>
                            <select
                                id="deleteReason"
                                className="form-select"
                                value={deleteReason}
                                onChange={(e) => setDeleteReason(e.target.value)}
                            >
                                <option value="">Select a reason for deletion</option>
                                <option value="Found a partner">Found a partner</option>
                                <option value="Not satisfied with the service">Not satisfied with the service</option>
                                <option value="Privacy concerns">Privacy concerns</option>
                                <option value="Other">Other</option>
                            </select>
                        </div>
                        <div className="d-flex justify-content-center gap-3">
                            <button className="btn btn-light px-4 rounded-pill" onClick={() => setShowDeletePopup(false)}>Cancel</button>
                            <button className="btn btn-danger px-4 rounded-pill" onClick={handleDeleteAccount}>Delete</button>
                        </div>
                    </div>
                </Popup>

                <Popup
                    show={showProfileControl}
                    onClose={() => setShowProfileControl(false)}
                >
                    <h5 className="fw-bold mb-3 center">
                        Profile Image Control
                    </h5>

                    {controlList.map((item) => (
                        <div
                            key={item.id}
                            className="form-check mb-2 mt-3"
                        >
                            <input
                                type="checkbox"
                                className="form-check-input"
                                checked={selectedControls?.includes(item.code) || false}
                                onChange={() => handleControlChange(item.code)}
                            />

                            <label className="form-check-label">
                                {item.name}
                            </label>
                        </div>
                    ))}

                    <div className="text-center mt-4">
                        <button
                            type="button"
                            style={{backgroundColor:"darkorange",color:"white"}}
                            className="btn border w-50"
                            onClick={saveImageControl}
                            disabled={isSavingImageControl}
                        >
                            {isSavingImageControl ? "Saving..." : "Save"}
                        </button>
                    </div>
                </Popup>

            </div>
            <footer className='bg-dark text-white text-center'>
                <label style={{ fontSize: "12px" }}>Copyright © 2026 NavGraph Technologies. All Rights Reserved.</label>
            </footer>
        </>
    );
}
export default Settingspage;